module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kBbhF"))).then(() => parcelRequire('d0iPb'));